import { useFormikContext } from "formik";
import type { FC, ReactNode } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { isNoticeWorkflow } from "../../clientProfile/tabs/cases/useCreateCaseForm";
import { TeamMembersPicker } from "../../clientProfile/components/TeamMembersPicker";
import type { NewCaseValues } from "../types";

const Field: FC<{
  id: string;
  label: string;
  hint?: string;
  error?: string | null;
  children: ReactNode;
}> = ({ id, label, hint, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <Label htmlFor={id} className="text-sm">
      {label}
    </Label>
    {children}
    {error ? (
      <p className="text-sm text-danger" role="alert">
        {error}
      </p>
    ) : hint ? (
      <p className="text-sm text-fg-3">{hint}</p>
    ) : null}
  </div>
);

/** Deadline and team: both optional. */
export const DetailsStep: FC = () => {
  const { values, setFieldValue } = useFormikContext<NewCaseValues>();
  const notice = isNoticeWorkflow(values.workflow);

  return (
    <div className="flex max-w-160 flex-col gap-5">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <Field
          id="new-case-deadline"
          label={notice ? "Response Due" : "Filing Deadline"}
          hint={
            notice && values.noticePreview?.status === "ready"
              ? "From the notice."
              : undefined
          }
        >
          <Input
            id="new-case-deadline"
            type="date"
            value={values.filingDeadline}
            onChange={(e) =>
              void setFieldValue("filingDeadline", e.target.value, false)
            }
          />
        </Field>
      </div>

      <Field id="new-case-team" label="Team">
        <TeamMembersPicker
          id="new-case-team"
          value={values.assignedUserIds}
          onChange={(ids) => void setFieldValue("assignedUserIds", ids, false)}
        />
      </Field>
    </div>
  );
};
